// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"TagSelect_dropdown__31E6r"};